import type { RoomSectionRenderItem } from "@multiconsult-group/multiplacer-ui";

export const mergeStreetViewRenderItems = (
  ifcItems: RoomSectionRenderItem[],
  localItems: RoomSectionRenderItem[],
  view: { center: [number, number] | null; radiusM: number }
): RoomSectionRenderItem[] => {
  const { center, radiusM } = view;
  const nearbyItems = localItems.filter(
    ({ item }) =>
      center &&
      item.geometry?.Obb3DWorldMmList?.some(
        (obb) =>
          Math.hypot(obb.centerM.x - center[0], obb.centerM.y - center[1]) <=
          radiusM + Math.hypot(obb.extentAM, obb.extentBM)
      )
  );
  return [...ifcItems, ...nearbyItems];
};
